import styles from './App.css';
import Home from './pages/home/Home';
import Login from './pages/login';
import MatrixProperties from './pages/matrixProperties/MatrixProperties';
import MatrixOperations from './pages/matrixOperations/MatrixOperations';
import Exercises from './pages/exercises/Exercises';

import React, { useEffect, useState } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import OAuth2RedirectHandler from "./oauth2";
import { getCurrentUser } from "./api";
import { ACCESS_TOKEN } from "./constants";
import NavBar from './components/navBar/NavBar';
import LoadingIndicator from "./components/loadingIndicator/LoadingIndicator";
import "./App.css";
import AddExercises from './components/addExercisesBox/AddExercisesBox';

const App = () => {
  const [isTeacher, setIsTeacher] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(false);
  

  const handleLogout = () => {
    setIsTeacher(false);
  }


  return (
    <div className="app">
      <div className={styles.navigation_wrapper}>
        <NavBar isTeacher={isTeacher} onLogout={handleLogout}/>
      </div>

      <div className="app-background">
        <svg width="300" height="650" viewBox="0 0 551 1132" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="804.02" height="804.02" rx="99" transform="matrix(0.710331 0.703868 0.710331 -0.703868 -592 566.076)" fill="#FFEAA7"/>
        </svg>
      </div>

      <div className="app-body">
        <Routes>
          <Route exact path="/" element={<Home />}></Route>
          <Route path="/matrix-properties" element={<MatrixProperties />} />
          <Route path="/matrix-operations" element={<MatrixOperations />} />
          <Route path="/exercises" element={<Exercises />} />
          <Route path="/add-exercises" element={<AddExercises />} />
          {/* <Route
            path="/login"
            element={<Login authenticated={authenticated}/>}
          /> */}
          <Route path="/oauth2/redirect" element={<OAuth2RedirectHandler setIsTeacher={setIsTeacher}/>} />
          <Route path="*" element={<Navigate replace to="/" />} />
        </Routes>
      </div>
    </div>
  );
}

export default App;

// function App() {
//   return (
//     <div className="App">
//         <div className={styles.main_wrapper}>
//             <div className={styles.navigation_wrapper}>
//                 <navBar/>
//             </div>
//             <UclApi/>

//             <Routes>
//                 <Route path="/" element={<Home/>}/>
//                 <Route path="/matrix-properties" element={<MatrixProperties/>}/>
//                 <Route path="/matrix-operations" element={<MatrixOperations/>}/>
//                 <Route path="/exercises" element={<Exercises/>}/>
//                 <Route path="*" element={<Navigate replace to="/"/>}/>
//             </Routes>
//         </div>
//     </div>
//   );
// }

// export default App;
